import { render, staticRenderFns } from "./StockMovementsPage.vue?vue&type=template&id=12e56943&scoped=true"
import script from "./StockMovementsPage.vue?vue&type=script&lang=js"
export * from "./StockMovementsPage.vue?vue&type=script&lang=js"
import style0 from "./StockMovementsPage.vue?vue&type=style&index=0&id=12e56943&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e56943",
  null
  
)

export default component.exports